import { render, staticRenderFns } from "./ReservaFinca.vue?vue&type=template&id=061f1042&"
import script from "./ReservaFinca.vue?vue&type=script&lang=js&"
export * from "./ReservaFinca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports